import React from 'react';
import { BookOpenIcon, GiftIcon, StarIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: UsersIcon,
  label: '+1.500 docentes de Yacimientos de Hidrocarburos'
}, {
  icon: BookOpenIcon,
  label: '9 tomos completos'
}, {
  icon: GiftIcon,
  label: '5 bonos incluidos'
}, {
  icon: StarIcon,
  label: '4.9/5 calificación'
}];
export function SocialProof() {
  return <section className="border-b border-line bg-white py-5" aria-label="Contenido del Megapack" data-id="element-241" data-mp="3ev2imgdu69y">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-muted sm:justify-between" data-id="element-242" data-mp="8dy9icfxamkk">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-243" data-mp="3ut0u4sl6r1p8">
            <Icon className="h-5 w-5 text-earth" aria-hidden="true" data-id="element-244" data-mp="3ur69zghqndm7" /> {label}
          </span>)}
      </div>
    </section>;
}